export const AUTH_DOMAIN = "auth/";

export const LOG_IN_SUCCESS = AUTH_DOMAIN + "login";
export const SET_USER_TOKEN = AUTH_DOMAIN + "setUserToken";
export const LOG_OUT = AUTH_DOMAIN + "logOut";
export const LOG_IN_WITH_PASSWORD = AUTH_DOMAIN + "loginWithPassword";
export const SET_INTERCEPTOR = AUTH_DOMAIN + "setInterceptor";
export const FIND_USER_TOKEN_IN_STORAGE = AUTH_DOMAIN + "findUserTokenInStorage";
export const GET_USER_DATA_BY_TOKEN = AUTH_DOMAIN + "getUserDataByToken";
export const SET_FAKE_SESSION = AUTH_DOMAIN + "setFakeSession";
export const FAKE_SESSION_LOG_IN = AUTH_DOMAIN + "fakeSessionLogIn";
export const FAKE_ADD_TO_BASKET = AUTH_DOMAIN + "fakeAddToBasket";
